module.exports = __webpack_public_path__ + "img/alert.9606bde5.svg";